export default __webpack_public_path__ + "static/media/branded-live-dealer.20fc7837.svg";